import { Button, Layout, Table, TableProps, Tag, DatePicker, Form, Input, Pagination, Select, Space, Modal, TableColumnsType, Radio, Tree, TreeNodeProps, TreeDataNode, Row, Col, Divider } from "antd"
import orgLogo from "../../assets/orgLogo.png"
import NCSlogo from "../../assets/ncs_logo.png"
import thumbsupIcon from "../../assets/svgs/thumbs-up-solid.svg"

import { useState, useEffect, useContext, useMemo } from "react"
import { capitalizeWords, getScreenSize, trimWholeWordsPastLimit } from "../../utilities/utilities"
import { AppStateContext } from "../../state/AppProvider";
import './AdminHome.css';
import UserContextMenu from "../../components/menu/UserContextMenu"
import { exportMessagesToCSV, getPaginatedUserMessages, getClassificationBreakdown } from "../../api/admin"
import { DateHelper } from "../../utilities/datehelper"
import { ExportOutlined, MinusCircleOutlined, PlusCircleOutlined, ArrowUpOutlined } from "@ant-design/icons"
import dayjs from 'dayjs'
import { getAllTopQueries } from "../../api"
import { CITATION_HEADINGS_PREFIX, CLASSIFICATIONS_LIST } from "../../constants/config"
import { CitationDisplayTypes } from "../../constants/enums"
import appNotificationInit from "../../components/common/notification"
import { mapChatMessageToSearchResult } from "../../utilities/mapToSearchResult"
import { SearchResultItemResponse } from "../../components/SearchResult/SearchResultItemResponse"
import CategoryBarChart from "./CategoryBarChart"

const dateFormat = 'DD/MM/YYYY'
const getFromDateString = () => {
    const today = new Date(Date.now())
    return today.toLocaleString("en-SG", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

const AdminHome = () => {
    const [darkmodeActive, setDarkmodeActive] = useState<boolean>(false);
    const [userMessages, setUserMessages] = useState<ChatMessage[]>([]);
    const [classificationCountMap, setClassificationCountMap] = useState<Record<string, number>>({});
    const [topQueriesTreeData, setTopQueriesTreeData] = useState<TreeDataNode[]>()
    const [totalRecords, setTotalRecords] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(false)
    const [filterUser, setFilterUser] = useState<string>('');
    const [filterFeedbackRatings, setFilterFeedbackRatings] = useState<string>();
    const [filterToDate, setFilterToDate] = useState<dayjs.Dayjs>(dayjs(getFromDateString(), dateFormat))
    const [filterFromDate, setFilterFromDate] = useState<dayjs.Dayjs>(filterToDate.add(-30, 'day'))
    const [filterClassification, setFilterClassification] = useState<string[]>([])
    const [nextToken, setNextToken] = useState<Map<number, string>>(new Map<number, string>())
    const [pageSize, setPageSize] = useState<number>(10)
    const [selectedReference, setSelectedReferences] = useState<SearchResultCitation>();
    const [openReferencesModal, setOpenReferencesModal] = useState<boolean>(false);

    appNotificationInit();

    const appStateContext = useContext(AppStateContext)
    const { RangePicker } = DatePicker;
    const options = CLASSIFICATIONS_LIST.map((item: string) => ({
        label: capitalizeWords(item),
        value: item
    }))
    const feedbackRatingsOptions = [
        {
            label: "All",
            value: "All"
        }, {
            label: <img className='flip180deg filter-white-primary' style={{ "transform": "rotate(180deg) translateY(-3px)" }} src={thumbsupIcon} alt="" />,
            value: "true"
        },
        {
            label: <img className='flip80deg filter-white-primary' style={{ "transform": "translateY(3px)" }} src={thumbsupIcon} alt="" />,
            value: "false"
        }]

    // const pageSize = 10
    const queryTableTitle = () => {
        return <><div className="fs16-fw600">Queries [{totalRecords}]</div>
            <Form layout="inline" className="p-3 br-16">
                <Space.Compact block>
                    <Form.Item className="mb-3" label="Period">
                        <RangePicker
                            className="br-8"
                            minDate={dayjs('2025-01-01', dateFormat)}
                            maxDate={dayjs(getFromDateString(), dateFormat)}
                            value={[filterFromDate, filterToDate]}
                            onChange={(dates, _) => {
                                // console.log(dates[0])
                                if (dates && dates[0])
                                    setFilterFromDate(dates[0])
                                if (dates && dates[1])
                                    setFilterToDate(dates[1])
                            }}
                        >
                        </RangePicker></Form.Item>
                    <Form.Item className="mb-3" label="User"><Input className="br-8" allowClear value={filterUser} onChange={(e) => setFilterUser(e.target.value)} /></Form.Item>
                    <Form.Item className="mb-3" label="Feedback Ratings">
                        <Radio.Group className="br-8" block
                            options={feedbackRatingsOptions}
                            optionType="button"
                            defaultValue='All'
                            onChange={(e) => setFilterFeedbackRatings(e.target.value)}
                        />
                    </Form.Item>
                </Space.Compact>
                <Space.Compact block>
                    <Form.Item label="Classification">
                        <Select className="br-8"
                            mode="multiple" allowClear
                            placeholder="Select classification(s)"
                            options={options}
                            style={{ width: 800 }}
                            onChange={onClassificationSelectChange}
                        /></Form.Item>
                    <Form.Item>
                        <Button className="btn-primary my-auto bg-root b-primary c-primary b-none br-16 pt-1 pb-1 me-2" icon={<ArrowUpOutlined />}
                            onClick={() => loadFilteredMessages()}
                        >Search</Button>
                        <Button className="btn-primary my-auto bg-root b-primary c-primary b-none br-16 pt-1 pb-1 ms-1" icon={<ExportOutlined />}
                            onClick={() => exportMessages()}
                        >Export</Button>
                    </Form.Item>
                </Space.Compact>
            </Form>
        </>
    }
    const queryTableFooter = () => {
        return <Pagination className='c-primary' align="center" simple={{ readOnly: true }} pageSize={pageSize} total={totalRecords} onChange={onPaginationChange} showSizeChanger ></Pagination>
    }

    const renderExpandableRow = (message: ChatMessage) => {
        const searchResult = mapChatMessageToSearchResult(message)
        return (
            <div>
                <div className="bg-white-a-50 p-3" style={{ margin: 0, padding: 10, borderRadius: 10 }}>
                    <SearchResultItemResponse
                        generatedTextWithCitations={searchResult.genratedTextWithInlineCitations}
                        handleSelectedReference={(reference) => { setSelectedReferences(reference); setOpenReferencesModal(true); }} />
                    {message.feedbackRating != null &&
                        <div className="bg-root d-flex p-1 mt-3" style={{ borderRadius: 10 }}>
                            {message.feedbackRating ? (
                                <img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" />
                            ) : (
                                <img className='flip80deg filter-white-primary' src={thumbsupIcon} alt="" />
                            )}
                            <div className='ms-3 d-flex mt-1 pb-1'>
                                <div className='c-default fs12-fw400 my-auto ms-2'>{message.feedbackComment}</div>
                            </div>
                        </div>}
                </div>
            </div>
        )
    }

    const tableProps: TableProps<ChatMessage> = {
        rowKey: "message_id",
        bordered: true,
        loading: loading,
        size: 'middle',
        title: queryTableTitle,
        showHeader: true,
        footer: queryTableFooter,
        tableLayout: "auto",
        pagination: false,
        expandable: {
            expandedRowRender: renderExpandableRow,
            fixed: "right",
            showExpandColumn: false,
            expandIcon: ({ expanded, onExpand, record }) =>
                expanded ? (
                    <MinusCircleOutlined onClick={e => onExpand(record, e)} />
                ) : (
                    <PlusCircleOutlined onClick={e => onExpand(record, e)} />
                )
        }
    };

    const columns: TableColumnsType<ChatMessage> = [
        Table.EXPAND_COLUMN,
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => <div style={{ whiteSpace: 'nowrap' }}>{DateHelper.formatLongDateTime(text)}</div>,
            minWidth: 100
        },
        {
            title: 'User',
            dataIndex: 'user_id',
            key: 'user_id',
            minWidth: 100
        },
        {
            title: 'Query',
            dataIndex: 'user_query',
            key: 'user_query',
            minWidth: 100,
            width: 400
        },
        {
            title: 'Response',
            dataIndex: 'assistant_reply',
            key: 'assistant_reply',
            render: (data: string) => <div>{trimWholeWordsPastLimit(data, 80)} </div>,
            minWidth: 100,
            width: 400
        },
        {
            title: 'Classifications',
            dataIndex: 'classification',
            key: 'classification',
            render: (data: Classification) => <div className='d-flex g-2 flex-wrap'>{data?.category3.map((item) => <Tag className='br-16 bg-root c-primary b-primary' key={item}>{capitalizeWords(item)}</Tag>)}</div>,
            minWidth: 200
        },
        {
            title: 'Feedback',
            children: [
                {
                    title: 'Rating',
                    dataIndex: 'feedbackRating',
                    key: 'feedbackRating',
                    render: (data: boolean) => <div style={{ justifyContent: 'center', display: 'flex' }}>{data != null && (data ? <img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /> : <img className='flip80deg filter-white-primary' src={thumbsupIcon} alt="" />)}</div>,
                    minWidth: 50
                },
                {
                    title: 'Comments',
                    dataIndex: 'feedbackComment',
                    key: 'feedbackComment',
                    render: (data: string) => <div>{data && trimWholeWordsPastLimit(data, 80)}</div>,
                    minWidth: 50
                }
            ]
        },
        {
            title: 'Agent',
            dataIndex: 'agent_id',
            key: 'agent_id',
            render: (data: string) => <div className='d-flex g-2 flex-wrap'>{appStateContext?.state?.agentOptions?.find((item) => item.id === data)?.name}</div>,
            minWidth: 200
        },
        {
            title: 'Copied',
            dataIndex: 'clipboardActivityCount',
            key: 'clipboardActivityCount',
            minWidth: 50,
            width: 50
        },
        // {
        //     title: 'Actions',
        //     key: 'action',
        //     render: (_,record) => <div><Button icon={<MessageOutlined/>} ></Button></div>,
        // }

    ];
    useEffect(() => {
        console.log("agent options", appStateContext?.state?.agentOptions)
        if (!appStateContext?.state?.agentOptions?.length || appStateContext?.state?.agentOptions?.length <= 0) {
            return
        }
        getAllTopQueries().then((faqs) => {
            if (faqs) {
                //populate tree data
                const topQueries = faqs.map((item) => {
                    const agentName = appStateContext?.state?.agentOptions?.find((agent) => agent.id === item.agent_id)?.name ?? item.agent_id

                    const toDate = DateHelper.dateSubtractDays(item.to_date, 1)
                    const fromDate = item.from_date
                    const title = `${agentName} [${DateHelper.formatDate(fromDate)} to ${DateHelper.formatDate(toDate.toDateString())}]`
                    return {
                        title: <div className="fs14-fw600">{title}</div>, key: item.agent_id,
                        children: item.queries.map((query, index) => {
                            return { title: <div>{query}</div>, key: `${item.agent_id}-${index}` }
                        })
                    }
                })
                setTopQueriesTreeData(topQueries)
            }
        })
    }, [appStateContext!.state.agentOptions])

    useEffect(() => {

        setDarkmodeActive(document.body.classList.contains('dark-mode') ?? false)
        const observer = new MutationObserver(() => {
            setDarkmodeActive(document.body.classList.contains("dark-mode"));
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        function handleResize() {
            const size = getScreenSize();
            appStateContext?.dispatch({ type: 'SCREEN_SIZE', payload: size });
        }

        window.addEventListener("resize", handleResize);
        handleResize()
        loadMessages()
        loadClassificationBreakdown();
    }, [])
    const exportMessages = () => {
        let filterParams: FilterParameters = {
            userId: filterUser,
            fromDate: filterFromDate.toISOString(), //from start of day
            toDate: filterToDate.add(1, 'day').add(-1, 'millisecond').toISOString(),//to end of day
        }
        if (filterClassification.length > 0) {
            filterParams.category_3 = filterClassification.join(",")
        }
        if (filterFeedbackRatings !== "All") {
            filterParams.feedbackRating = filterFeedbackRatings
        }
        exportMessagesToCSV(filterParams)
    }

    const loadFilteredMessages = () => {
        loadMessages();
        loadClassificationBreakdown();
    } 


    const loadMessages = (nextToken: string | null = null, pageNumber: number = 1, pageSizeInput: number = pageSize) => {
        // console.log('to date', filterToDate.toISOString())
        // console.log('from date', filterFromDate.toISOString())
        setLoading(true)
        let filterParams: FilterParameters = {
            pageSize: pageSizeInput,
            userId: filterUser,
            fromDate: filterFromDate.toISOString(), //from start of day
            toDate: filterToDate.add(1, 'day').add(-1, 'millisecond').toISOString(),//to end of day
        }
        // console.log("next token", nextToken)
        if (nextToken) {
            filterParams.nextToken = nextToken
        }
        if (filterClassification.length > 0) {
            filterParams.category_3 = filterClassification.join(",")
        }
        if (filterFeedbackRatings !== 'All') {
            filterParams.feedbackRating = filterFeedbackRatings
        }
        getPaginatedUserMessages(filterParams).then((paginatedResponse) => {
            // console.log("messages", paginatedResponse)
            if (paginatedResponse) {
                setUserMessages(paginatedResponse.items)
                setTotalRecords(paginatedResponse.total_count)
                // setCurrentPageNumber(pageNumber)
                if (paginatedResponse.next_token) {
                    setNextToken(prev => prev.set(pageNumber + 1, JSON.stringify(paginatedResponse.next_token)))
                }
            }
            setLoading(false)
        });
    }
    const onClassificationSelectChange = (value: any) => {
        setFilterClassification(value)
    }
    const onPaginationChange = (pageNumber: number, updatedPageSize: number) => {
        //if page number is more (go to next)
        if (updatedPageSize !== pageSize) {
            setPageSize(updatedPageSize)
            loadMessages(null, 1, updatedPageSize)
        } else {
            if (pageNumber === 1) {
                loadMessages()
            }
            if (nextToken.has(pageNumber)) {
                loadMessages(nextToken.get(pageNumber), pageNumber)
            } else {
                loadMessages()
            }
        }
    }

    const loadClassificationBreakdown = async () => {
        const filterParams: FilterParameters = {
            userId: filterUser,
            fromDate: filterFromDate.toISOString(),
            toDate: filterToDate.add(1, 'day').add(-1, 'millisecond').toISOString(),
        };

        if (filterClassification.length > 0) {
            filterParams.category_3 = filterClassification.join(",");
        }

        if (filterFeedbackRatings !== 'All') {
            filterParams.feedbackRating = filterFeedbackRatings;
        }

        const breakdown = await getClassificationBreakdown(filterParams);
        if (breakdown) {
            setClassificationCountMap(breakdown);
        }
    };


    return (<>
        <Modal

            title={selectedReference?.main_title}
            open={openReferencesModal}
            onCancel={() => {
                setOpenReferencesModal(false);
                setSelectedReferences(undefined);
            }}
            cancelText="Close"
            cancelButtonProps={{
                className: 'bg-primary br-16 c-root b-primary pt-2 pb-2'
            }}
            okButtonProps={{
                className: 'bg-primary br-16 c-root b-primary pt-2 pb-2',
                style: { display: 'none' }
            }}
            className={`custom-modal ${(appStateContext?.state?.screenSize ?? 3) < 3 ? 'small-screen-modal' : ''}`}
        >
            {selectedReference && (
                <>
                    <div className='fs16-fw600 c-default'>
                        {selectedReference.display_type === CitationDisplayTypes.FULL || selectedReference.display_type === CitationDisplayTypes.MAIN_TITLE_WITH_SUBTITLE || selectedReference.display_type === CitationDisplayTypes.CUSTOM_URL
                            ? (
                                <div className='fs16-fw600 c-default'>
                                    {CITATION_HEADINGS_PREFIX}
                                    {decodeURIComponent(selectedReference.title ?? '')}
                                </div>
                            )
                            : ``
                        }
                        {selectedReference.display_type === CitationDisplayTypes.FULL || selectedReference.display_type === CitationDisplayTypes.MAIN_TITLE_WITH_URL
                            ? (
                                <a
                                    href={decodeURIComponent(
                                        selectedReference.encoded_url ?? ''
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='fs14-fw500 c-default t-underline'>
                                    {decodeURIComponent(
                                        selectedReference.encoded_url ?? ''
                                    )}
                                </a>
                            )
                            : ``
                        }
                        {(selectedReference.display_type === CitationDisplayTypes.CUSTOM_URL && selectedReference.url) && (
                            <div className='fs14-fw400 c-default cur-pointer t-underline' onClick={() => window.open(selectedReference.url, '_blank')}>
                                {selectedReference.url}
                            </div>
                        )}
                    </div>
                    <div className='bg-white p-3 br-16'>
                        <div className="fs16-fw400 c-default references-modal-text">
                            {selectedReference.content.split("\n").map((line, index) => (
                                <span key={index}>{line}<br /></span>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </Modal>

        <Layout className='d-flex d-flex-column bg-none' style={{ height: '100vh', minWidth: '1200px' }}>
            <Layout.Header className='d-flex g-3 bg-none' style={{ height: '10vh' }}>
                {import.meta.env.VITE_APP_SHOW_ORG_LOGO === "ENABLED" &&<img alt="Organisation logo"
                    src={orgLogo}
                    className='my-auto filter-normal-white'
                    aria-hidden="true"
                    style={{ height: '50px', width: 'auto' }}
                />}
                <img alt="NCS logo"
                    src={NCSlogo}
                    className='my-auto filter-normal-white'
                    aria-hidden="true"
                    style={{ height: '20px', width: 'auto' }}
                />
                <div className='fs24-fw600 t-a-center c-primary my-auto' style={{ width: '80%' }}>Dashboard</div>
                <UserContextMenu />
            </Layout.Header>
            <Layout.Content className='d-flex-grow d-flex-column d-flex justify-content-start' style={{ paddingLeft: '50px', paddingRight: '50px', paddingBottom: '20px', justifyContent: 'center', height: '90vh' }}>
                <div className='c-primary mb-2 fs16-fw600'>{import.meta.env.VITE_APP_TITLE}</div>
                <div className="bg-white-a-50 p-3 mb-2 br-16">
                    <span className="fs16-fw600 c-primary">Top Queries By Agents</span>
                    <Tree
                        className="pb-2 pt-3 fs14-fw400 c-primary d-flex"
                        selectable={false}
                        treeData={topQueriesTreeData}
                    />
                </div>
                <Table<ChatMessage>
                    className='d-flex-grow d-flex-column d-flex justify-content-start'
                    dataSource={userMessages} columns={columns}
                    {...tableProps}
                />

                <Divider orientation="left" className="fs16-fw600 c-primary"></Divider>
                {Object.keys(classificationCountMap).length > 0 && (
                <div style={{ paddingBottom: '20px' }}>
                    <CategoryBarChart categoryCountMap={classificationCountMap} isDarkmodeActive={darkmodeActive} />
                </div>
                )}
                
            </Layout.Content>
        </Layout>
    </>)
}

export default AdminHome